import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { isAnalyticsConsented } from 'lib/firebase/utils';

const useTrackingConsent = () => {
  const location = useLocation();

  const [isTrackingConsented, setIsTrackingConsented] = useState(() =>
    isAnalyticsConsented()
  );

  useEffect(() => {
    const consented = isAnalyticsConsented();
    setIsTrackingConsented(consented);
  }, [location.pathname]);

  return {
    isTrackingConsented
  };
};

export default useTrackingConsent;
